import React from 'react';
import { Box, Fade } from '@material-ui/core';
import type { IServiceClient } from 'src/interfaces/serviceClient';
import type { TServiceClientVehicle } from 'src/interfaces/serviceClient';
import { VehicleCard } from './VehicleCard';
import { ClientDetailCard } from './ClientDetailCard';

export type ServiceClientInfoProps = {
    client: IServiceClient | null;
    vehicles: TServiceClientVehicle[];
    selectedTab: number;
    canUpdateServiceClient: boolean;
};

export const ServiceClientInfo = ({
    client,
    vehicles,
    selectedTab,
    canUpdateServiceClient,
}: ServiceClientInfoProps) => {
    const selectedVehicle = vehicles[selectedTab] ?? null;

    return (
        <Fade in={true} timeout={600}>
            <Box
                display="flex"
                flexDirection="column"
                style={{ gap: '1em' }}
                data-testid="service-client-info-cards"
            >
                <ClientDetailCard client={client} editPath={canUpdateServiceClient && client?._id ? `/management/service-clients/${client._id}/edit` : undefined} />
                {vehicles.length > 0 && selectedVehicle && (
                    <VehicleCard
                        vehicle={selectedVehicle}
                        editPath={
                            canUpdateServiceClient &&
                                client?._id &&
                                selectedVehicle.serviceVehicleId
                                ? `/management/service-clients/${client._id}/vehicles/${selectedVehicle.serviceVehicleId}/edit`
                                : undefined
                        }
                    />
                )}
            </Box>
        </Fade>
    );
};
